
  import {
    AppModule
  } from '@/store/modules/app';
  import {
    Component,
    Vue
  } from 'vue-property-decorator'

  @Component({
    name: 'page-footer'
  })
  export default class PageFooter extends Vue {
    get isCollapse() {
      return !AppModule.sidebar.opened;
    }
  }
